export default __webpack_public_path__ + "static/media/(3).05a92d65.jpg";